// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { datePlugin } from '@atlaskit/editor-plugin-date';
export type {
	DatePlugin,
	DatePluginDependencies,
	DatePluginSharedState,
	DatePluginConfig,
	DatePluginOptions,
	DateType,
	InsertDate,
} from '@atlaskit/editor-plugin-date';
